// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const TargetSettingConfig = lazy(
  () => import('pages/targetConfig/targetConfig')
);

const TargetSettingConfigRoute = (
  <Route path={routeName.targetConfiguration}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.TARGET_SETTING_CONFIG_VIEW}>
          <Suspense fallback={<Loading />}>
            <TargetSettingConfig />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default TargetSettingConfigRoute;
